document.addEventListener('DOMContentLoaded', function () {
  const gbBuilderGalleries = document.querySelectorAll('[data-gb-builder-gallery]');

  if (gbBuilderGalleries.length === 0) return;

  function setActiveGbBuilderGalleryTab(gbBuilderGallery, activeTab) {
    const tabs = gbBuilderGallery.querySelectorAll('.gb-builder-gallery__tab');
    const panels = gbBuilderGallery.querySelectorAll('.gb-builder-gallery__panel');

    tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      const panelId = tab.getAttribute('aria-controls');
      const panel = panelId ? gbBuilderGallery.querySelector(`#${panelId}`) : null;

      tab.classList.toggle('gb-builder-gallery__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');

      if (panel) {
        panel.classList.toggle('gb-builder-gallery__panel--active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      }
    });

    panels.forEach((panel) => {
      const ownsPanel = Array.from(tabs).some((tab) => tab.getAttribute('aria-controls') === panel.id);

      if (!ownsPanel) {
        panel.toggleAttribute('hidden', true);
      }
    });
  }

  function setupGbBuilderGallery(gbBuilderGallery) {
    const tabs = gbBuilderGallery.querySelectorAll('.gb-builder-gallery__tab');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        setActiveGbBuilderGalleryTab(gbBuilderGallery, tab);
      });
    });
  }

  gbBuilderGalleries.forEach(setupGbBuilderGallery);
});
